//in the API this is considered an alertPreference, but it's referred to as an 'Alert' in the UI.

export class Alert {
    id: string;
    name: string;
    //get the name and id from a base Alert
    fromJson(dict: any): Alert {
        this.id = dict.id;
        this.name = dict.name;
        return this;
    }

    fromJsonArray(array: any[]): Alert[] {
        let ret: Alert[] = [];
        array.forEach((dict) => {
            ret.push(new Alert().fromJson(dict));
        });
        return ret;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/alert.ts